module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "epub4231-6.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN para-style-override-1",
    attrs: {
      "id": "toc_marker-7",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("Revenge is a kind of grace . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "EPIS-align"
  }, [_vm._v("Tim Lott, "), _c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Under the Same Stars")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d3c66f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epub4231-6.vue
// module id = 78
// module chunks = 0